import { linearProgressClasses } from "@mui/material";

const styles = (isMobile) => ({
  container: {
    padding: isMobile ? "16px" : "2vh 0vw",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "32px",
  },
  title: {
    fontWeight: 400,
    color: "#0D0D0E",
    marginBottom: "8px",
    fontSize: isMobile ? "28px" : "20px",
    lineHeight: 1.2,
  },
  subtitle: {
    color: "#949daa",
    fontWeight: 500,
  },
  addButton: {
    backgroundColor: "#4d6bf6",
    color: "white",
    borderRadius: "8px",
    padding: "10px 20px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "14px",
    boxShadow: "0 2px 4px rgba(25, 118, 210, 0.2)",
    "&:hover": {
      backgroundColor: "#1565c0",
      boxShadow: "0 4px 8px rgba(25, 118, 210, 0.3)",
    },
  },
  roomCard: {
    borderRadius: "16px",
    transition: "all 0.3s ease-in-out",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    border: "1px solid #E5E7EB",
    cursor: "pointer",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
      borderColor: "#e0e0e0",
    },
  },
  cardImage: {
    borderRadius: "16px 16px 0 0",
    objectFit: "cover",
    height: isMobile ? "120px" : "160px",
    width: "100%",
  },
  cardContent: {
    flexGrow: 1,
    padding: isMobile ? "12px" : "2vh 1vw",
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  roomName: {
    fontWeight: 600,
    color: "#0D0D0E",
    marginBottom: "0",
    fontSize: "14px",
  },
  roomTypeChip: {
    backgroundColor: "#e3f2fd",
    color: "#4d6bf6",
    fontWeight: 600,
    fontSize: "12px",
    borderRadius: "20px",
    padding: "4px 12px",
    marginBottom: "16px",
    alignSelf: "flex-start",
  },
  roomDetail: {
    color: "#666",
    marginBottom: "6px",
    fontSize: "12px",
    lineHeight: 1.4,
    "& strong": {
      color: "#333",
      fontWeight: 600,
    },
  },
  detailsSection: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
  },
  styleSection: {
    marginTop: "auto",
    paddingTop: "12px",
    borderTop: "1px solid #f5f5f5",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "60px 20px",
  },
  emptyState: {
    textAlign: "center",
    padding: "60px 20px",
    color: "#666",
  },
  emptyStateTitle: {
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "12px",
    color: "#333",
  },
  emptyStateSubtitle: {
    fontSize: "16px",
    marginBottom: "24px",
  },
});

export default styles;
